import type { ClassData, LibraryData } from '@/core/types/library.type'
import { classifyTypeUsage } from '@/core/utils/mappers/formatTypeUsage/classifyTypeUsage'
import type { NodeLike } from '@/core/utils/mappers/formatTypeUsage/types'

import { collectAssemblyNamesFromParameterShape } from './collectAssemblyNamesFromParameterShape'

const collectFromTypeUsage = (typeUsage: NodeLike | null | undefined, assemblyNames: Set<string>): void => {
  if (!typeUsage) return
  collectAssemblyNamesFromParameterShape(classifyTypeUsage(typeUsage), assemblyNames)
}

const collectFromClass = (classData: ClassData, assemblyNames: Set<string>): void => {
  for (const method of Object.values(classData.methods ?? {})) {
    collectFromTypeUsage(method.returnTypeUsage, assemblyNames)
    for (const parameter of method.parameters) {
      collectFromTypeUsage(parameter.typeUsage, assemblyNames)
    }
  }

  for (const field of Object.values(classData.fields ?? {})) {
    collectFromTypeUsage(field.fieldTypeUsage, assemblyNames)
  }

  for (const constructor of Object.values(classData.constructors ?? {})) {
    for (const parameter of constructor.parameters) {
      collectFromTypeUsage(parameter.typeUsage, assemblyNames)
    }
  }

  for (const child of Object.values(classData.children ?? {})) {
    collectFromClass(child, assemblyNames)
  }
}

export const collectAssemblyNamesFromLibrary = (
  libraryData: LibraryData | undefined,
  classData: ClassData | undefined
): Set<string> => {
  const assemblyNames = new Set<string>()

  if (!libraryData) return assemblyNames

  if (classData) {
    collectFromClass(classData, assemblyNames)
    return assemblyNames
  }

  for (const entry of Object.values(libraryData.classes ?? {})) {
    collectFromClass(entry, assemblyNames)
  }

  return assemblyNames
}
